<script setup lang="ts">
import { PATH_PARAMETERS_LICENSE } from "~/modules/license/constants";
import { useLicenseStore } from "~/modules/license/stores/useLicenseStore";
import ILxcAlertTriangle from "~icons/lxc/alert-triangle";
import ILxcArrowRight from "~icons/lxc/arrow-right";

const { t } = useI18n();

const router = useRouter();

const { isLicenseExpirationDateExceeded, isLicenseDevicesCountExceeded } =
  useLicenseStore();

const dateExceeded = isLicenseExpirationDateExceeded();
const devicesCountExceeded = isLicenseDevicesCountExceeded();

function goToLicensePage(event: Event) {
  event.preventDefault();
  router.push(PATH_PARAMETERS_LICENSE);
}
</script>

<template>
  <lxc-alert
    v-if="dateExceeded || devicesCountExceeded"
    type="warning"
    :icon="ILxcAlertTriangle"
    closable
  >
    <template #title>{{ t("license.warning.title") }}</template>

    <template #default>
      <p>
        <template v-if="dateExceeded">
          {{ t("license.warning.expirationDateExceeded") }}
        </template>

        <template v-else-if="devicesCountExceeded">
          {{ t("license.warning.devicesCountExceeded") }}
        </template>
      </p>

      <p class="mt-4 mb-0">
        <a
          :href="PATH_PARAMETERS_LICENSE"
          class="font-semibold flex !text-warning-700 redirect"
          @click="goToLicensePage"
          >{{ t("license.warning.redirect") }}
          <i-lxc-arrow-right class="ml-2" height="1.25rem" width="1.25rem"
        /></a>
      </p>
    </template>
  </lxc-alert>
</template>

<style lang="scss" scoped>
a.redirect {
  &:hover {
    opacity: 0.7;
  }
  &:active {
    opacity: 1;
  }
}
</style>
